import globalPlayer from "./globalPlayer"
export default globalPlayer;
